import { useEffect, useState } from 'react'
import { ChannelRow } from './channel-row'
import { ProgramDrawer } from '../program-drawer'
import { Channel } from '../../types'
import { useApp } from '../app-context'

export const ChannelGrid = () => {
  const onProgramClick = (
    id: number | undefined,
    channel: Channel | undefined,
    date: string | undefined = undefined
  ) => {
    if (id) {
      const url = new URL(window.location.href)
      url.searchParams.set('programId', String(id))
      url.searchParams.set('channel', channel?.callLetter || '')
      url.searchParams.set('date', date || '')
      window.history.pushState({}, '', url.toString())
    } else {
      const url = new URL(window.location.href)
      url.searchParams.delete('programId')
      url.searchParams.delete('channel')
      url.searchParams.delete('date')
      window.history.pushState({}, '', url.toString())
    }

    setSelectedInfo({
      programId: id,
      channel: channel,
      date: date,
    })
  }
  const { channelData } = useApp()
  const [selectedInfo, setSelectedInfo] = useState<
    | {
        programId: number | undefined
        channel: Channel | undefined
        date: string | undefined
      }
    | undefined
  >(undefined)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 960)
  const [caretOffset, setCaretOffset] = useState<number>(0)
  useEffect(() => {
    function handleWindowSizeChange() {
      setIsMobile(window.innerWidth <= 960)
    }

    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  const { originalOffset } = useApp()
  useEffect(() => {
    if (caretOffset === 0 && originalOffset !== 0) {
      setCaretOffset(originalOffset + window.innerWidth / 2)
    }
  }, [originalOffset])
  return (
    <div className="channel-grid" id="channel-grid">
      {channelData?.map((channel) => (
        <ChannelRow
          key={channel.id}
          channel={channel}
          onProgramClick={onProgramClick}
          isMobile={isMobile}
        />
      ))}

      <div
        className="caret-tv-guide"
        style={{
          transform: `translateX(${caretOffset}px)`,
        }}
      />
      <ProgramDrawer
        programId={selectedInfo?.programId}
        onProgramClick={onProgramClick}
        channel={selectedInfo?.channel}
        date={selectedInfo?.date}
      />
    </div>
  )
}
